import { apiClient } from "shared/utils";
import { QuestionnaireIntegration } from "api/models";

export const getIntegrations = async () => {
  const { data } = await apiClient.get<QuestionnaireIntegration>("questionnaire/integrations");

  return data;
};
